import React from "react";
import { Col, Row } from "antd";
import { FaInstagram, FaFacebook, FaTwitter, FaLinkedinIn } from "react-icons/fa";
import { Link } from "react-router-dom"; // Add this import for navigation
import Container from "../../../common/Container/Container";
import "../../../styles/layoutCss/footer.css";

const HomeFooter = () => {
  return (
    <Container>
      <Row gutter={[32, 32]} justify="space-between">
        <Col xs={24} sm={12} md={6} lg={6}>
          <p className="heading">Spoflex</p>
          <p className="company-name">SPOFLEX (PRIVATE) LTD</p>
          <Row>
            <Col xs={4} sm={4} md={6} lg={4}>
              <FaInstagram
                onClick={() => window.open("https://www.instagram.com/spoflexofficial", "_blank")}
                className="iconShow socialIcons"
              />
            </Col>
            <Col xs={4} sm={4} md={6} lg={4}>
              <FaFacebook
                onClick={() => window.open("https://www.facebook.com/spoflexofficial", "_blank")}
                className="iconShow socialIcons"
              />
            </Col>
            <Col xs={4} sm={4} md={6} lg={4}>
              <FaTwitter
                onClick={() => window.open("https://www.twitter.com/spoflex_off", "_blank")}
                className="iconShow socialIcons"
              />
            </Col>
            <Col xs={4} sm={4} md={6} lg={4}>
              <FaLinkedinIn
                onClick={() =>
                  window.open("https://www.linkedin.com/in/spoflex-in-ab8420257/", "_blank")
                }
                className="iconShow socialIcons"
              />
            </Col>
            <Col sm={8} xs={8} md={6} lg={8}></Col>
          </Row>
        </Col>

        <Col xs={24} sm={12} md={6} lg={6}>
          <p className="iconShow">Company</p>
          <Link to="/" className="textColor footer-link">
            Home
          </Link>
          <Link to="/about-us" className="textColor footer-link">
            About Us
          </Link>
          <Link to="/contact-us" className="textColor footer-link">
            Contact Us
          </Link>
        </Col>
      </Row>
    </Container>
  );
};

export default HomeFooter;
